import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleHeart: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-heart, comment, feedback"><path d="M20.25 3.75H3.75V18.25H9.0155L11.9979 20.75L15.0155 18.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15.2507 10.6676C15.2507 13.0001 11.9994 14.2802 11.9994 14.2802C11.9994 14.2802 8.74805 13.0001 8.74805 10.6676C8.74805 8.91956 10.4957 7.87886 11.9994 8.85008C13.5031 7.87886 15.2507 8.91956 15.2507 10.6676Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBubbleHeart;
